import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UsoProvider {

  apiRoot: string = 'http://192.99.185.73:8070';

  constructor(public http: HttpClient) {
    console.log('Hello UsoProvider Provider');
  }

  getTopColaboradoresRequisicao(DataInicial: string, DataFinal: string, Email: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    var mail = Email? '&email='+ Email : '';

    return this.http
      .get(this.apiRoot + '/Dashboard/TopColaboradoresRequisicao?'
                        + 'DataInicial=' + DataInicial
                        + '&DataFinal='+ DataFinal
                        + mail, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  getURequisicoes(Limite: number){

    const header = new HttpHeaders({ 'Content-Type':  'application/json',
                                     'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
      .get(this.apiRoot + '/Dashboard//UltimasRequisicoes?Limite='
                        + Limite, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};
    if (error.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;

        console.log(error.error);

    } else {

        errorMessage = { status: error.status, message: error.error.Message };

        console.log(errorMessage);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/uso/uso.ts